import type { User } from '../../user/user.types';

/**
 * Checks if device registration is required for the given user.
 *
 * This function determines if the user has the deviceRegistration
 * scope, indicating that device registration is required.
 *
 * @param user - The user to check.
 * @returns True if device registration is required, false otherwise.
 */
export const isDeviceRegistrationRequired = (user: User) =>
  Boolean(user.scope?.includes('device:register'));
